'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.days = exports.months = exports.format = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _formatter = require('./formatter');

Object.defineProperty(exports, 'format', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_formatter).default;
  }
});

var _months2 = require('./months');

Object.defineProperty(exports, 'months', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_months2).default;
  }
});

var _days2 = require('./days');

Object.defineProperty(exports, 'days', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_days2).default;
  }
});

var _formatter2 = _interopRequireDefault(_formatter);

var _months3 = _interopRequireDefault(_months2);

var _days3 = _interopRequireDefault(_days2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var sortGlobalArgs = function sortGlobalArgs(globalArgs) {
  var args = [].concat(_toConsumableArray(globalArgs));
  var isLocalFirst = typeof args[0] === 'string';
  // local is not defined so we create a gap at the end
  // this will later revers so that the local will be the first param
  if (args.length === 1 && !isLocalFirst) {
    args.push(null);
  }
  return isLocalFirst ? args : args.reverse();
};

var getFormatArgs = function getFormatArgs(globalArgs, localArgs) {
  var args = [].concat(_toConsumableArray(localArgs));

  var _sortGlobalArgs = sortGlobalArgs(globalArgs),
      _sortGlobalArgs2 = _slicedToArray(_sortGlobalArgs, 2),
      globalLocal = _sortGlobalArgs2[0],
      globalDate = _sortGlobalArgs2[1];
  // case if template is the first and thuse a date is missing


  if (typeof args[0] === 'string') {
    args.unshift(globalDate);
  }

  // last argument is not defined, we need to add the local
  if (!args[2]) {
    args.push(globalLocal);
  }
  return args;
};

var intlDTFactory = function intlDTFactory() {
  for (var _len = arguments.length, globalArgs = Array(_len), _key = 0; _key < _len; _key++) {
    globalArgs[_key] = arguments[_key];
  }

  var _sortGlobalArgs3 = sortGlobalArgs(globalArgs),
      _sortGlobalArgs4 = _slicedToArray(_sortGlobalArgs3, 1),
      globalLocal = _sortGlobalArgs4[0];

  return {
    format: function format() {
      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return _formatter2.default.apply(undefined, _toConsumableArray(getFormatArgs(globalArgs, args)));
    },
    months: function months(type) {
      return (0, _months3.default)(globalLocal, type);
    },
    days: function days(type) {
      return (0, _days3.default)(globalLocal, type);
    }
  };
};

exports.default = intlDTFactory;
//# sourceMappingURL=index.js.map